import AdminShell from "@/components/admin/AdminShell";
import AcademyMediaManager from "@/components/admin/AcademyMediaManager";

export default function AdminEthicsMedia() {
  return (
    <AdminShell title="Stoic Ethics · Media Slots">
      <div data-testid="admin-ethics-media-page">
        <AcademyMediaManager discipline="ethics" />
      </div>
    </AdminShell>
  );
}
